import { DeliveryDashboardSettings } from "app/types/deliveryDashboardSettings";
import { RouteStop } from "app/types/route";
import { getRelationId } from "app/utils/odooDisplay";

export function isManualRouteReleaseMode(
  settings: DeliveryDashboardSettings | null | undefined
): boolean {
  return !settings?.route_reassignment?.auto_release_picking_on_not_delivered;
}

export function canReleaseStopForReassignment(
  stop: RouteStop,
  manualReleaseMode: boolean
): boolean {
  if (!manualReleaseMode) {
    return false;
  }
  if (stop.is_active === false) {
    return false;
  }
  if (stop.delivery_status !== "not_delivered") {
    return false;
  }
  return getRelationId(stop.picking_id) != null;
}

export function isArchivedRouteStop(stop: RouteStop): boolean {
  return stop.is_active === false;
}
